import { ReduxKit } from '@team/redux';
import { eventNamed } from '../model';

export const languageChanged = ReduxKit.createEvent<string>(
  eventNamed('language-changed')
);
